import DOMPurify from 'dompurify';

import { Label } from '~api/api';

import { Dialog } from '~src/main/dialog/dialog';
import { DialogLayout } from '~src/main/dialog/dialog-layout';

import { FullscreenComponent } from '~src/main/fullscreen-internals/fullscreen-component';

const sanitizeOptions = {
  ALLOWED_TAGS: ['a', 'br', 'b', 'strong'],
  ALLOWED_ATTR: ['target', 'href'],
};

interface LabelModalFullscreenProps {
  labels: Label[];
  title: string;
  onClose: () => void;
}

export const LabelModalFullscreen: FullscreenComponent<LabelModalFullscreenProps> = ({
  labels,
  title,
  onClose,
}) => {
  const elements = labels.map((label: Label, idx: number) => {
    return (
      <div
        key={idx}
        className="label-wrapper"
        css={{
          fontSize: '14px',
          lineHeight: '20px',
          marginBottom: '24px',
        }}
      >
        <div
          css={{
            fontVariationSettings: '"wght" 500',
            marginBottom: '2px',
          }}
          role="term"
        >
          {label.name}
        </div>
        {label.description && (
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(label.description, sanitizeOptions),
            }}
            role="definition"
          />
        )}
      </div>
    );
  });

  return (
    <Dialog width={520} onClose={() => onClose()}>
      <DialogLayout title={title} onClose={() => onClose()}>
        {elements}
      </DialogLayout>
    </Dialog>
  );
};
LabelModalFullscreen.fullscreenName = 'LabelModalFullscreen';
